export default "__VITE_ASSET__fd52281d__"